// extracted by mini-css-extract-plugin
module.exports = {"butn":"button-module--butn--sC30k","butnBg":"button-module--butn-bg--3qGxV","butnLight":"button-module--butn-light--3-JSX","butnBord":"button-module--butn-bord--3zjPp"};